import {Action} from '@ngrx/store';
import {DepartmentSubscription, Invoice, Product} from '@app/core/models/subscription.model';
import {Card} from '@app/core/models/card.model';
import {Pagination} from '@app/core/models/pagination.model';

export enum ESubscriptionActions {
	GetSubscriptions = '[Subscription] Get Subscriptions',
	GetSubscriptionsSuccess = '[Subscription] Get Subscriptions Success',

	GetProducts = '[Subscription] Get Products',
	GetProductsSuccess = '[Subscription] Get Products Success',

	GetInvoices = '[Subscription] Get Invoices',
	GetInvoicesSuccess = '[Subscription] Get Invoices Success',

	SubscribeToPlan = '[Subscription] Subscribe To Plan',
	SubscribeToPlanSuccess = '[Subscription] Subscribe To Plan Success',

	UnsubscribeToPlan = '[Subscription] Unsubscribe To Plan',
	UnsubscribeToPlanSuccess = '[Subscription] Unsubscribe To Plan Success',

	GetCard = '[Subscription] Get Cards',
	GetCardSuccess = '[Subscription] Get Cards Success',

	AddCard = '[Subscription] Add Card',
	AddCardSuccess = '[Subscription] Add Card Success',

	SetIsLoading = '[Subscription] Set loading',
	GetHostedInvoice = '[Subscription] Get Hosted Invoice',

}

export class UnsubscribeToPlan implements Action {
	public readonly type = ESubscriptionActions.UnsubscribeToPlan;

	constructor(public subscription: DepartmentSubscription) {
	}
}

export class UnsubscribeToPlanSuccess implements Action {
	public readonly type = ESubscriptionActions.UnsubscribeToPlanSuccess;

	constructor(public subscription: DepartmentSubscription) {
	}
}

export class SetIsLoading implements Action {
	public readonly type = ESubscriptionActions.SetIsLoading;

	constructor(public loading: boolean, public loadingKey: string = 'isLoading') {
	}
}

export class AddCard implements Action {
	public readonly type = ESubscriptionActions.AddCard;

	constructor(public token: string, public department_id: number) {
	}
}

export class AddCardSuccess implements Action {
	public readonly type = ESubscriptionActions.AddCardSuccess;

	constructor(public card: Card) {
	}
}

export class GetCard implements Action {
	public readonly type = ESubscriptionActions.GetCard;

	constructor(public department_id: number) {
	}
}

export class GetCardSuccess implements Action {
	public readonly type = ESubscriptionActions.GetCardSuccess;

	constructor(public card: Card) {
	}
}

export class GetSubscriptions implements Action {
	public readonly type = ESubscriptionActions.GetSubscriptions;

	constructor(public department_id: number) {
	}
}

export class GetSubscriptionsSuccess implements Action {
	public readonly type = ESubscriptionActions.GetSubscriptionsSuccess;

	constructor(public subscriptions: DepartmentSubscription[]) {
	}
}

export class GetInvoices implements Action {
	public readonly type = ESubscriptionActions.GetInvoices;

	constructor(public department_id: number, public page: number, public pageSize: number = 10) {
	}
}

export class GetInvoicesSuccess implements Action {
	public readonly type = ESubscriptionActions.GetInvoicesSuccess;

	constructor(public invoices: Invoice[], public pagination: Pagination) {
	}
}

export class GetProducts implements Action {
	public readonly type = ESubscriptionActions.GetProducts;

	constructor() {
	}
}

export class GetProductsSuccess implements Action {
	public readonly type = ESubscriptionActions.GetProductsSuccess;

	constructor(public products: Product[]) {
	}
}

export class SubscribeToPlan implements Action {
	public readonly type = ESubscriptionActions.SubscribeToPlan;

	constructor(
		public department_id: number, public product_id: number, public plan_id: number,
	) {
	}
}

export class SubscribeToPlanSuccess implements Action {
	public readonly type = ESubscriptionActions.SubscribeToPlanSuccess;

	constructor(public subscription: DepartmentSubscription) {
	}
}

export class GetHostedInvoice implements Action {
	public readonly type = ESubscriptionActions.GetHostedInvoice;

	constructor(public id: number) {
	}
}

export type SubscriptionActions =
	GetSubscriptions |
	GetSubscriptionsSuccess |
	GetInvoices |
	GetInvoicesSuccess |
	GetProducts |
	GetProductsSuccess |
	SubscribeToPlan |
	SubscribeToPlanSuccess |
	GetCard |
	GetCardSuccess |
	AddCard |
	AddCardSuccess |
	UnsubscribeToPlan |
	UnsubscribeToPlanSuccess |
	SetIsLoading |
	GetHostedInvoice
	;
